import React, { Suspense } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { createRoot } from 'react-dom/client';
import { ToastContainer } from 'react-toastify';

import MainSiteLayout from 'buyside/components/presentation/MainSiteLayout/mainSiteLayout';

import lazyWithRetry from 'buyside/util/lazyWithRetry';

import generateClient from 'buyside/apollo/client';
import generatePublicClient from 'open/apollo/publicClient';

document.addEventListener('DOMContentLoaded', () => {
  const reactRootEl = document.getElementById('reactAppRoot');
  if (!reactRootEl) return;

  const rootPageName = reactRootEl.dataset.rootPageName;
  const hideNavigation = reactRootEl.dataset.hideNavigation === 'true';
  const rootPageEl = document.getElementById(`${rootPageName}`);
  if (!rootPageEl) return;

  const RootPage = lazyWithRetry(() =>
    import(
      /* webpackChunkName: "rootPages" */
      /* webpackMode: "eager" */
      `buyside/components/rootPages/${rootPageName}`
    )
  );

  const currentUserFromRails = reactRootEl.dataset.currentUser
    ? JSON.parse(reactRootEl.dataset.currentUser)
    : null;
  const flashMessages = reactRootEl.dataset.flashMessages
    ? JSON.parse(reactRootEl.dataset.flashMessages)
    : [];

  const client = currentUserFromRails ? generateClient() : generatePublicClient();

  const root = createRoot(reactRootEl);
  root.render(
    <ApolloProvider client={client}>
      <ToastContainer
        autoClose={false}
        position="bottom-right"
        style={{
          maxWidth: 450,
          width: '100%',
          ['--toastify-color-light']: '#fff',
          ['--toastify-color-dark']: '#1c242c',
          ['--toastify-color-info']: '#4a90e2',
          ['--toastify-color-success']: '#5ab457',
          ['--toastify-color-warning']: '#bbb545',
          ['--toastify-color-error']: '#d51800'
        }}
      />
      <MainSiteLayout
        currentUserFromRails={currentUserFromRails}
        flashMessages={flashMessages}
        hideNavigation={hideNavigation}
        RootComponent={
          <Suspense>
            <RootPage {...rootPageEl.dataset} />
          </Suspense>
        }
      />
    </ApolloProvider>
  );
});
